<div class="td-wb-account-selector__container">
  <td-wb-dropdown class="td-wb-account-selector__dropdown"
                  name="accountDropdown"
                  [attr.id]="uniqueId"
                  [panelMaxHeight]="310"
                  [placeholder]="showPlaceholder() ? ('tdWb.components.accountSelector.ACCOUNT_PLACEHOLDER' | tdWbTranslate) : undefined"
                  [ariaLabel]="'tdWb.components.accountSelector.ACCOUNT_ARIA' | tdWbTranslate"
                  [disabled]="isDisabled()"
                  [ngModel]="selectedAccount()"
                  [comparator]="comparator('id')"
                  (ngModelChange)="onModelChange($event)">
    <td-wb-dropdown-toggle class="td-wb-account-selector__dropdown__toggle">
      <ng-container [ngTemplateOutlet]="accountLabel"
                    [ngTemplateOutletContext]="{ account: selectedAccount() }" />
    </td-wb-dropdown-toggle>
    @for (account of accounts(); track account) {
      <td-wb-dropdown-item class="td-wb-account-selector__dropdown__item"
                           [value]="account">
        <ng-container [ngTemplateOutlet]="accountLabel"
                      [ngTemplateOutletContext]="{ account: account }" />
      </td-wb-dropdown-item>
    }
  </td-wb-dropdown>
  <ng-content />
</div>

<ng-template #accountLabel let-account="account">
  @if (account !== undefined && account.id !== '$ALL') {
    <td-wb-account-label [account]="account" />
  }
  @if (account?.id === '$ALL') {
    <div><span translate="tdWb.components.accountSelector.ALL_ACCOUNTS_PLACEHOLDER"></span></div>
  }
</ng-template>
